export default __webpack_public_path__ + "static/media/demo3.2ac3424b.png";